import script from "./welfareTreasure.vue?vue&type=script&setup=true&lang=js"
export * from "./welfareTreasure.vue?vue&type=script&setup=true&lang=js"

import "./welfareTreasure.vue?vue&type=style&index=0&id=51892e12&lang=css"
import "./welfareTreasure.vue?vue&type=style&index=1&id=51892e12&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51892e12"]])

export default __exports__